<script>
import { ConfettiMessage } from "@kci/confetti-vue";

export default {
  name: "AuthContainer",
  components: {
    ConfettiMessage,
  },

  props: {
    title: {
      type: String,
      required: true,
    },

    error: {
      type: String,
      default: "",
    },
  },
};
</script>

<template>
  <div class="flex login-container">
    <div class="login-panel">
      <div class="login-badge">
        <img
          class="logo-image"
          src="@/assets/login-logo.svg"
          :alt="$t('Assistant')"
        />
      </div>

      <section>
        <h1>{{ title }}</h1>

        <ConfettiMessage
          v-if="error"
          type="error"
          hide-icon="true"
          can-close="false"
        >
          {{ error }}
        </ConfettiMessage>

        <div class="auth-content">
          <slot />
        </div>
      </section>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "confetti/scss/variables/colors";
@import "confetti/scss/variables/typography";

h3 {
  margin-block-start: 0.3rem;
  text-align: center;
}

section {
  padding-block-start: 1.3rem;

  h1 {
    text-align: center;
  }
}

.logo-image {
  block-size: 81px;
  inline-size: 255px;
}

.login-badge {
  text-align: center;
}

.login-container {
  align-items: center;
  justify-content: center;
}

.login-panel {
  inline-size: 42rem;
}

.normal {
  font-weight: $normal;
}
</style>
